import {API_URLS} from '@/const/urls';
import {http} from '@/helper/http';

export const kycApi = {
  getSummary() {
    return http.get(API_URLS.KYC_SUMMARY, {
      formatter(data) {
        data.country = data.country || '-';
        data.idNumber = data.idNumber || '-';
        data.idType = data.idType || '-';
        const {firstName, lastName} = data;
        data.fullName = firstName && lastName ? firstName + ' ' + lastName : '-';
        data.firstName = firstName || '-';
        data.lastName = lastName || '-';
        return data;
      },
    });
  },
  checkEnable() {
    return http.get(API_URLS.KYC_CHECK_ENABLE, {});
  },
  getSdkToken(userId, lang) {
    return http.post(API_URLS.KYC_JUMIO_TOKEN, {params: {lang}});
  },
  check() {
    const params = {};
    return http.post(API_URLS.KYC_JUMIO_CHECK, {params});
  },
  getCountries() {
    return http.get(API_URLS.KYC_COUNTRIES, {});
  },
  getBonus() {
    return http.get(API_URLS.GET_BONUS, {});
  },
  getAllKycSummary() {
    return http.get(API_URLS.GET_ALL_KYC_SUMMAY, {});
  },
  getCountryRegions() {
    return http.get(API_URLS.KYC_COUNTRY_REGIONS, {});
  },
  getDocumentTypesByCountry(country) {
    return http.get(API_URLS.KYC_COUNTRY_DOCUMENT_TYPES, {
      query: {country},
    });
  },
  getUserBasicKycInfo() {
    return http.get(API_URLS.KYC_BASIC_INFO, {});
  },
  setBasicKycInfo(params) {
    return http.post(API_URLS.KYC_BASIC_SUBMIT, {params});
  },
  getJumioSdkToken(params) {
    return http.post(API_URLS.KYC_JUMIO_TOKEN, {params});
  },
  getJumioSdkTokenPublic(params) {
    return http.post(API_URLS.KYC_JUMIO_TOKEN_PUBLIC, {params});
  },
  getJumioKycConfig(query) {
    return http.get(API_URLS.KYC_JUMIO_CONFIG, {query});
  },
  getNotLoginCode(params) {
    return http.post(API_URLS.KYC_JUMIO_GEN_CODE, {params});
  },
  verifyCode(params) {
    return http.post(API_URLS.KYC_JUMIO_VERIFY_CODE, {params});
  },
  collectQuestion(params) {
    return http.post(API_URLS.KYC_JUMIO_COLLECT_QUESTION, {params});
  },
  collectQuestionPublic(params) {
    return http.post(API_URLS.KYC_JUMIO_COLLECT_QUESTION_PUBLIC, {params});
  },
  collectKycInfo(params) {
    return http.post(API_URLS.BASIC_KYC_AMEND, {params});
  },
  collectKycInfoPublic(params) {
    return http.post(API_URLS.BASIC_KYC_AMEND_PUBLIC, {params});
  },
  kycRecommend() {
    return http.get(API_URLS.KYC_RECOMMEND, {});
  },
  uploadProofAddressFile(formData) {
    return http.upload(API_URLS.KYC_UPLOAD_PROOF_ADDRESS_FILE + '?type=ADDRESS_PROOF', {formData});
  },
  getUploadProofOfAddressUrl(query) {
    return http.get(API_URLS.KYC_UPLOAD_PROOF_ADDRESS_URL, {query});
  },
  uploadProofOfAddress(url, params) {
    return http.put(`http://localhost:5000/proxy?url=${url}`, {params});
  },
};
